(function(){
  "use strict";

  function initHDrag(el){
    var down=false,sx=0,sl=0,moved=false;
    el.addEventListener('pointerdown',function(e){
      if(e.target.closest('button')&&!e.target.closest('.dbp-review-card')) return;
      down=true;moved=false;sx=e.clientX;sl=el.scrollLeft;el.classList.add('grabbing');
    });
    el.addEventListener('pointermove',function(e){
      if(!down)return;
      var d=e.clientX-sx;
      if(Math.abs(d)>4){moved=true;el.setPointerCapture&&el.setPointerCapture(e.pointerId);}
      el.scrollLeft=sl-d;
    });
    function up(){down=false;el.classList.remove('grabbing');}
    el.addEventListener('pointerup',up);
    el.addEventListener('pointercancel',up);
    el.addEventListener('pointerleave',up);
    el.addEventListener('click',function(e){ if(moved){e.preventDefault();e.stopPropagation();} },true);
  }

  function initHDragAll(root){
    root.querySelectorAll('.dbp-hscroll,.dbp-drag-row,.dbp-gallery,.dbp-review-track,.dbp-video-row,.dbp-marquee').forEach(initHDrag);
  }

  function initAccordions(root){
    root.querySelectorAll('.dbp-acc-head').forEach(function(h){
      h.addEventListener('click',function(){
        var item=h.parentElement;
        item.classList.toggle('open');
        var sym=h.querySelector('.sym');
        if(sym) sym.innerHTML = item.classList.contains('open') ? '&minus;' : '+';
      });
    });
  }

  function money(cents,fmt){
    var v=(cents/100).toFixed(2);
    return (fmt||'Q{{amount}}').replace('{{amount}}',v);
  }

  function initVariants(root){
    var data=root.getAttribute('data-dbp-variants');
    if(!data) return;
    var variants;
    try{ variants=JSON.parse(data); }catch(e){ return; }
    var fmt=root.getAttribute('data-dbp-money')||'Q{{amount}}';
    var idInput=root.querySelector('[data-dbp-variant-input]');
    var nowEl=root.querySelector('[data-dbp-price-now]');
    var wasEl=root.querySelector('[data-dbp-price-was]');
    var offEl=root.querySelector('[data-dbp-price-off]');
    var atc=root.querySelector('[data-dbp-atc]');
    var groups=Array.prototype.slice.call(root.querySelectorAll('[data-dbp-option]'));
    if(!groups.length) return;

    function selection(){
      return groups.map(function(g){
        var sel=g.querySelector('.dbp-swatch.selected');
        return sel?sel.getAttribute('data-value'):null;
      });
    }
    function match(){
      var sel=selection();
      return variants.filter(function(v){
        return sel.every(function(s,i){ return s===null || v.options[i]===s; });
      })[0];
    }
    function render(){
      var v=match();
      if(!v) return;
      if(idInput) idInput.value=v.id;
      if(nowEl) nowEl.textContent=money(v.price,fmt);
      if(wasEl){
        if(v.compare>v.price){ wasEl.textContent=money(v.compare,fmt); wasEl.style.display=''; }
        else wasEl.style.display='none';
      }
      if(offEl){
        if(v.compare>v.price){ offEl.textContent='-'+Math.round((1-v.price/v.compare)*100)+'%'; offEl.style.display=''; }
        else offEl.style.display='none';
      }
      if(atc){
        atc.disabled=!v.available;
        atc.textContent=v.available?(atc.getAttribute('data-label')||'AGREGAR AL CARRITO'):'AGOTADO';
      }
      // marcar combinaciones sin stock
      groups.forEach(function(g,gi){
        g.querySelectorAll('.dbp-swatch').forEach(function(b){
          var test=selection(); test[gi]=b.getAttribute('data-value');
          var hit=variants.filter(function(vv){
            return test.every(function(s,i){ return s===null||vv.options[i]===s; });
          })[0];
          b.classList.toggle('soldout', !!(hit && !hit.available));
        });
      });
    }
    groups.forEach(function(g){
      g.querySelectorAll('.dbp-swatch').forEach(function(b){
        b.addEventListener('click',function(){
          g.querySelectorAll('.dbp-swatch').forEach(function(o){o.classList.remove('selected');});
          b.classList.add('selected');
          render();
        });
      });
    });
    render();
  }

  function initMarquee(root){
    root.querySelectorAll('.dbp-marquee').forEach(function(el){
      var dir = el.getAttribute('data-dbp-dir')==='left' ? -1 : 1;
      var originals = Array.prototype.slice.call(el.children);
      if(!originals.length) return;
      originals.forEach(function(c){ el.appendChild(c.cloneNode(true)); });
      var half = 0;
      function measure(){ half = el.scrollWidth/2; }
      measure();
      window.addEventListener('resize', measure);
      if(dir < 0) el.scrollLeft = half;
      var paused = false;
      ['pointerdown','pointerenter'].forEach(function(ev){ el.addEventListener(ev,function(){paused=true;}); });
      ['pointerup','pointerleave','pointercancel'].forEach(function(ev){ el.addEventListener(ev,function(){paused=false;}); });
      var speed = 0.28;
      var pos = dir < 0 ? half : 0;
      function frame(){
        if(!paused && half > 0){
          pos += dir*speed;
          if(pos >= half) pos -= half;
          if(pos <= 0) pos += half;
          el.scrollLeft = pos;
        } else {
          pos = el.scrollLeft;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    });
  }

  function initCountdown(root){
    var el=root.querySelector('[data-dbp-countdown]');
    if(!el) return;
    var key='dbpDeadline';
    var end=parseInt(localStorage.getItem(key)||'0',10);
    if(!end||end<Date.now()){ end=Date.now()+1000*60*60*8; localStorage.setItem(key,String(end)); }
    function tick(){
      var d=Math.max(0,end-Date.now());
      var h=Math.floor(d/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      function p(n){return n<10?'0'+n:''+n;}
      el.textContent=p(h)+':'+p(m)+':'+p(s);
    }
    tick(); setInterval(tick,1000);
  }

  function buildReviews(root){
    var track=root.querySelector('[data-dbp-review-track]');
    if(!track) return;
    var list;
    try{ list=JSON.parse(root.getAttribute('data-dbp-reviews')||'[]'); }catch(e){ list=[]; }
    track.innerHTML=list.map(function(r){
      var stars=''; for(var i=0;i<5;i++) stars += i<r.stars ? '\u2605' : '\u2606';
      return '<div class="dbp-review-card"><div class="body">'+
        '<div class="stars">'+stars+'</div>'+
        '<div class="rname">'+r.name+'</div>'+
        '<p>'+r.text+'</p>'+
        '<div class="meta"><span>'+r.city+'</span><span class="v">\u2713 Compra verificada</span></div>'+
        '</div></div>';
    }).join('');
    var prev=root.querySelector('[data-dbp-review-prev]');
    var next=root.querySelector('[data-dbp-review-next]');
    function step(dir){
      var card=track.querySelector('.dbp-review-card');
      if(!card) return;
      track.scrollBy({left:dir*(card.offsetWidth+14),behavior:'smooth'});
    }
    if(prev) prev.addEventListener('click',function(){step(-1);});
    if(next) next.addEventListener('click',function(){step(1);});
  }

  function initTrackSlider(root,trackSel,dotsSel,auto){
    var track=root.querySelector(trackSel);
    if(!track) return;
    var dots=dotsSel?root.querySelector(dotsSel):null;
    function update(){
      if(!dots) return;
      var cards=track.children;
      if(!cards.length) return;
      var i=Math.round(track.scrollLeft/(cards[0].offsetWidth+14));
      Array.prototype.forEach.call(dots.children,function(d,di){ d.classList.toggle('active',di===i); });
    }
    track.addEventListener('scroll',update);
    if(auto){
      setInterval(function(){
        var cards=track.children;
        if(!cards.length) return;
        var w=cards[0].offsetWidth+14;
        var next=track.scrollLeft+w;
        if(next>track.scrollWidth-track.clientWidth-4) next=0;
        track.scrollTo({left:next,behavior:'smooth'});
      },auto);
    }
    update();
  }

  function initLightbox(root){
    var box=root.querySelector('.dbp-lightbox');
    if(!box) return;
    var img=box.querySelector('img');
    var imgs=Array.prototype.slice.call(root.querySelectorAll('[data-dbp-zoom]'));
    var idx=0;
    function show(i){ idx=(i+imgs.length)%imgs.length; img.src=imgs[idx].src; box.classList.add('open'); }
    imgs.forEach(function(el,i){ el.addEventListener('click',function(){ show(i); }); });
    box.querySelector('.close').addEventListener('click',function(){ box.classList.remove('open'); });
    box.querySelector('.prev').addEventListener('click',function(e){ e.stopPropagation(); show(idx-1); });
    box.querySelector('.next').addEventListener('click',function(e){ e.stopPropagation(); show(idx+1); });
    box.addEventListener('click',function(e){ if(e.target===box) box.classList.remove('open'); });
    document.addEventListener('keydown',function(e){
      if(!box.classList.contains('open')) return;
      if(e.key==='Escape') box.classList.remove('open');
      if(e.key==='ArrowLeft') show(idx-1);
      if(e.key==='ArrowRight') show(idx+1);
    });
  }

  function initPopup(root){
    var el=root.querySelector('[data-dbp-popup]');
    if(!el) return;
    var buyers=[
      {name:'Mar\u00eda',city:'Ciudad de Guatemala'},
      {name:'Jos\u00e9',city:'Mixco'},
      {name:'Ana',city:'Quetzaltenango'},
      {name:'Luc\u00eda',city:'Villa Nueva'},
      {name:'Carlos',city:'Antigua Guatemala'}
    ];
    var txtEl=el.querySelector('[data-dbp-popup-text]');
    var imgEl=el.querySelector('[data-dbp-popup-img]');
    var thumb=root.querySelector('.dbp-gallery img');
    if(thumb&&imgEl) imgEl.src=thumb.src; else if(imgEl) imgEl.style.display='none';
    var closed=false,i=0;
    function show(){
      if(closed) return;
      var b=buyers[i%buyers.length];
      txtEl.innerHTML='<b>'+b.name+'</b> desde '+b.city+' compr\u00f3 este producto hace '+(Math.floor(Math.random()*20)+2)+' minutos';
      el.classList.add('show'); i++;
      setTimeout(function(){ el.classList.remove('show'); },5000);
    }
    el.querySelector('[data-dbp-popup-close]').addEventListener('click',function(){ closed=true; el.classList.remove('show'); });
    setTimeout(show,4000);
    setInterval(function(){ if(!el.classList.contains('show')) show(); },14000);
  }

  function init(){
    document.querySelectorAll('.dbp[data-dbp-root]').forEach(function(root){
      initHDragAll(root);
      initAccordions(root);
      initVariants(root);
      initMarquee(root);
      initCountdown(root);
      buildReviews(root);
      initTrackSlider(root,'.dbp-review-track','.dbp-review-dots',null);
      initTrackSlider(root,'.dbp-drag-row',null,null);
      initLightbox(root);
      initPopup(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
